import React from 'react';
import { Link } from 'react-router-dom';

const TrainingNavbar = () => {
    return (
        <div className="absolute mt-2 bg-white shadow-md rounded px-4 py-2 z-50 w-64">
            <ul className="space-y-1 text-sm relative">

                {/* Front-End Development */}
                <li className="group relative">
                    <span className="cursor-default text-gray-800 font-semibold group-hover:text-[#2F55D4]">
                        Front-End Development
                    </span>
                    <div className="absolute top-0 left-full ml-1 hidden group-hover:block bg-white shadow-md rounded px-4 py-2 w-48 z-50">
                        <ul>
                            <li><Link to="/training/angularjs" className="block text-black hover:text-[#2F55D4]">AngularJS</Link></li>
                            <li><Link to="/training/reactjs" className="block text-black hover:text-[#2F55D4]">ReactJS</Link></li>
                        </ul>
                    </div>
                </li>

                {/* Back-End Development */}
                <li className="group relative">
                    <span className="cursor-default text-gray-800 font-semibold group-hover:text-[#2F55D4]">
                        Back-End Development
                    </span>
                    <div className="absolute top-0 left-full ml-1 hidden group-hover:block bg-white shadow-md rounded px-4 py-2 w-56 z-50">
                        <ul>
                            <li><Link to="/training/nodejs" className="block text-black hover:text-[#2F55D4]">Node.js</Link></li>
                            <li><Link to="/training/django" className="block text-black hover:text-[#2F55D4]">Django</Link></li>
                            <li><Link to="/training/java" className="block text-black hover:text-[#2F55D4]">Java (Spring Boot)</Link></li>
                        </ul>
                    </div>
                </li>

                {/* Data Science */}
                <li className="group relative">
                    <span className="cursor-default text-gray-800 font-semibold group-hover:text-[#2F55D4]">
                        Data Science & Analytics
                    </span>
                    <div className="absolute top-0 left-full ml-1 hidden group-hover:block bg-white shadow-md rounded px-4 py-2 w-56 z-50">
                        <ul>
                            <li><Link to="/training/python" className="block text-black hover:text-[#2F55D4]">Python</Link></li>
                            <li><Link to="/training/powerbi" className="block text-black hover:text-[#2F55D4]">Power BI</Link></li>
                            <li><Link to="/training/data-science" className="block text-black hover:text-[#2F55D4]">Data Science</Link></li>
                        </ul>
                    </div>
                </li>

                {/* DevOps */}
                <li className="group relative">
                    <span className="cursor-default text-gray-800 font-semibold group-hover:text-[#2F55D4]">
                        DevOps & Cloud
                    </span>
                    <div className="absolute top-0 left-full ml-1 hidden group-hover:block bg-white shadow-md rounded px-4 py-2 w-48 z-50">
                        <ul>
                            <li><Link to="/training/aws" className="block text-black hover:text-[#2F55D4]">AWS</Link></li>
                            <li><Link to="/training/azure" className="block text-black hover:text-[#2F55D4]">Azure</Link></li>
                        </ul>
                    </div>
                </li>

                {/* UI/UX */}
                <li className="group relative">
                    <span className="cursor-default text-gray-800 font-semibold group-hover:text-[#2F55D4]">
                        UI/UX Design
                    </span>
                    <div className="absolute top-0 left-full ml-1 hidden group-hover:block bg-white shadow-md rounded px-4 py-2 w-48 z-50">
                        <ul>
                            <li><Link to="/training/figma" className="block text-black hover:text-[#2F55D4]">Figma</Link></li>
                        </ul>
                    </div>
                </li>

            </ul>
        </div>
    );
};

export default TrainingNavbar;
